/* tslint:disable */
/* eslint-disable */
/**
 * PRTIMES Media User API
 * メディアユーザーマイページ用 API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessCategoryItem
 */
export interface BusinessCategoryItem {
    /**
     * busi_cate_idに相当
     * @type {string}
     * @memberof BusinessCategoryItem
     */
    categoryId: string;
    /**
     * busi_cate_lv2_idに相当
     * @type {number}
     * @memberof BusinessCategoryItem
     */
    categoryLv2Id: number;
    /**
     * ビジネスカテゴリ名
     * @type {string}
     * @memberof BusinessCategoryItem
     */
    name: string;
    /**
     * 受信設定がされているかを表すフラグ
     * @type {boolean}
     * @memberof BusinessCategoryItem
     */
    isReceiving: boolean;
}

export function BusinessCategoryItemFromJSON(json: any): BusinessCategoryItem {
    return BusinessCategoryItemFromJSONTyped(json, false);
}

export function BusinessCategoryItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessCategoryItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'categoryId': json['category_id'],
        'categoryLv2Id': json['category_lv2_id'],
        'name': json['name'],
        'isReceiving': json['is_receiving'],
    };
}

export function BusinessCategoryItemToJSON(value?: BusinessCategoryItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'category_id': value.categoryId,
        'category_lv2_id': value.categoryLv2Id,
        'name': value.name,
        'is_receiving': value.isReceiving,
    };
}

